import Footer from '@/Components/Partials/Footer';
import { publicUrl } from '@/Helpers/general';
import '@/Themes/Default/Styles/public-page-layout.scss';

import React from 'react';
import {Link} from "react-router-dom";

const PublicPageLayout = ({ children }) => {
    return (
        <div className="public-page-layout">
            <div className="flex flex-column align-items-center justify-content-center h-full">
                <div>
                    <Link className="site-logo uppercase-dark-text p-link flex justify-content-center align-items-center mt-5" to={publicUrl('home')}>
                        <img src="/img/nightingale-logo.png"/>
                    </Link>
                    {children}
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default PublicPageLayout;
